/**
 * How long `/entrar` may wait on the first in-flight pending-terms fetch
 * before proceeding into the app. Signing in must not depend on the tenant
 * database being healthy; the app shell still enforces terms once a later
 * fetch succeeds.
 */
export const TERMS_GATE_HOLD_MS = 3_000;

/**
 * Hold the post-login `/entrar` → returnUrl navigation only while the first
 * pending-terms fetch is genuinely in flight and the short ceiling has not
 * elapsed. Errors and background refetches must not re-block the redirect.
 */
export function isTermsGateHoldingEntrar(input: {
  termsQueryEnabled: boolean;
  isPending: boolean;
  holdExpired: boolean;
}): boolean {
  return input.termsQueryEnabled && input.isPending && !input.holdExpired;
}
